import { Element } from 'slate'
import { ReactEditor } from 'slate-react'

export function isTopLevel(editor: ReactEditor, element: Element) {
  const path = ReactEditor.findPath(editor, element)

  // If the element is a void, its path will be one level deeper than expected since there will be
  // a text node inside the void element. We need to account for that.
  if (editor.isVoid(element)) {
    path.pop()
  }
  // If the type is a ref, we need to go up one more level
  if ('type' in element && element.type === 'ref') {
    path.pop()
  }
  const isTopLevel = path?.length === 1
  return isTopLevel
}

export const getElementPath = (editor: ReactEditor, element: Element) => ReactEditor.findPath(editor, element)

export const ElementQueries = {
  isTopLevel,
  getElementPath,
}
